// Intended use is with NewPasswordField that trims whitespace from user input
// client/src/features/authentication/NewPasswordField/NewPasswordField.tsx

const MIN_PASSWORD_CHARACTERS = 8;
export const testMinChars = (password: string) =>
  Boolean(password.length >= MIN_PASSWORD_CHARACTERS);
export const testMinLetters = (password: string) => /[a-z]/i.test(password);
export const testMinNumbers = (password: string) => /\d/.test(password);

export const isNewPasswordValid = (password: string) =>
  testMinChars(password) &&
  testMinLetters(password) &&
  testMinNumbers(password);
